// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"7e039aaa","453":"8ab44547","847":"0c251d0a"}[chunkId] + ".chunk.js";
};